import { ReactNode } from 'react';
import cx from 'classnames';

import styles from './Pill.module.sass';

interface PillProps {
  children?: ReactNode;
  text?: string;
  tooltipText?: string;
  isRounded?: boolean;
  className?: string;
}

const Pill = ({
  children,
  text,
  tooltipText,
  isRounded,
  className,
}: PillProps) => {
  const classes = cx(
    styles.pill,
    {
      [`${styles['is-rounded']}`]: isRounded,
    },
    className,
  );

  return (
    <div className={classes} title={tooltipText}>
      {text && <span className={styles.text}>{text}</span>}
      {children}
    </div>
  );
};

export default Pill;
